import 'whatwg-fetch';

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { iterUnpack, defaultLogoImageUrl, prepareImgixParams } from '../../services/APIClient';
import SegmentClient from '../../services/SegmentClient';
import Alert from '../Alert';
import { ANALYTICS_NAME } from './Constants';
import { BrandResource } from '../../services/RESTClient';
import { MEDIA_QUERIES } from '../../services/constants';

const segment = new SegmentClient();

const SimilarBrandsWrapper = styled.div`
  && {
    border: 1px solid;
    position: relative;
    
   @media screen and (max-width: ${MEDIA_QUERIES.small}) {
    padding-top: 2.1875rem !important;
   }
    
    .similar-brands-cards {
      flex-wrap: wrap;
    }
  }
`;

const PremiumStyle = styled.span`
  && {
    padding-bottom: 0.1rem;
    padding-left: 0.5rem;
    padding-right: 0.4rem;
    border-radius: 0.2rem;
    font-size: 0.875rem;
    top: 0.625rem;
  }
`;

const SimilarBrandCard = styled.a`
  && {
    display: block;
    color: inherit;
    padding: 0.625rem;
    border: 1px solid;
    transition: color .3s;
    height: 100%;
    
    &:hover, &:focus {
      color: black;
    }
  }
`;

export default class BrandDetailSimilarBrands extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.defaultState();
  }

  UNSAFE_componentWillMount() {
    const props = iterUnpack(JSON.parse(window.props));
    const brand = props.allBrands[0];
    this.setState({
      isLoading: false,
      brands: (brand.similarBrands || []).map(similarBrand => ({
        ...similarBrand,
        isPremium: BrandResource.isPremium(similarBrand),
      })),
    });
  }

  getImageUrl = (logoImageUrl) => {
    if (logoImageUrl !== null) {
      return prepareImgixParams(logoImageUrl, {
        w: 54, h: 54, fit: 'clip', auto: 'format,compress',
      });
    }
    return defaultLogoImageUrl;
  }

  defaultState = () => ({
    isLoading: false,
    brands: [],
  });

  render() {
    const { brands } = this.state;
    const { showUpgradeMessage } = this.props;
    return (
      <SimilarBrandsWrapper className="p-base bg-extra-light-gray border-global-separator mt-base">
        <PremiumStyle className="p-a white bg-blue">Premium</PremiumStyle>
        <h3 className="text-center mb-l fs-m fw-medium">Similar Premium Brands on Architizer</h3>
        <div className="row align-center">
          <div className="columns xlarge-8 medium-10 small-12">
            {brands && brands.length
              ? (
                <div className="row align-center similar-brands-cards">
                  {brands.map(({
                    djangoId,
                    name,
                    slug,
                    logoImageUrl,
                    productsCount,
                    projectsCount,
                    firmsCount,
                  }) => (
                    <div className="columns medium-4 large-2 small-6 mb-xs" key={djangoId}>
                      <SimilarBrandCard
                        className="border-global-separator bg-white text-center"
                        href={`/brands/${slug}`}
                        onClick={() => segment.track(ANALYTICS_NAME.BRAND_SIMILAR_BRAND_CLICKED, {
                          link_url: `${window.location.origin}/brands/${slug}`,
                          clicked_brand_id: djangoId,
                          clicked_brand_name: name,
                          clicked_brand_slug: slug,
                        })}
                      >
                        <h4 className="ellipsis fs-base mb-xs">{name}</h4>
                        <div className="flex-container align-middle">
                          <img alt={name} src={this.getImageUrl(logoImageUrl)} className="mr-xs" />
                          <div className="text-center">
                            {productsCount > 0 && <h6 className="m-0">{productsCount} product{productsCount > 1 && 's'}</h6>}
                            {projectsCount > 0 && <h6 className="m-0">{projectsCount} project{projectsCount > 1 && 's'}</h6>}
                            {firmsCount > 0 && <h6 className="m-0">{firmsCount} firm{firmsCount > 1 && 's'}</h6>}
                          </div>
                        </div>
                      </SimilarBrandCard>
                    </div>
                  ))}
                </div>
              )
              : (
                <Alert type="secondary">
                  No Similar Brands Available
                </Alert>
              )}
          </div>
        </div>
        {showUpgradeMessage
        && (
        <div className="text-center mt-base">
          <a
            href="https://join.architizer.com/media-kit/"
            target="_blank"
            rel="noreferrer"
            onClick={this.props.handlePremiumLearnMore}
          >
            Learn more about Premium Membership
          </a>
        </div>
        )}
      </SimilarBrandsWrapper>
    );
  }
}

BrandDetailSimilarBrands.propTypes = {
  showUpgradeMessage: PropTypes.bool,
  handlePremiumLearnMore: PropTypes.func,
};

BrandDetailSimilarBrands.defaultProps = {
  showUpgradeMessage: false,
  handlePremiumLearnMore: () => {},
};
